import { get } from '../utils/axios'


export const getPaymentsAPI = async () => {
  return await get('payments')
}